import { apiAsync } from '../common/helpers'

const getPresignedUrl = (s3BucketName, s3Key, region) => {
  return apiAsync({
    api: 'external/platformService/presignedUrl',
    method: 'GET',
    params: {
      verb: 'get',
      s3BucketName,
      fileName: s3Key,
      fileType: 'pdf',
      region
    }
  })
}

const openPdf = async (s3BucketName, s3Key, region) => {
  const url = await getPresignedUrl(s3BucketName, s3Key, region)
  window.open(url)
}

const getPlanograms = async (params) => {
  const response = await apiAsync({
    baseURL: process.env.ELC_API_DOMAIN,
    api: '/postings/updates',
    params,
    method: 'GET'
  })

  return response.data
}

module.exports = { openPdf, getPlanograms }
